module.exports = __webpack_public_path__ + "static/media/Magical Quest 3 - Box Cover.37d05d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/box/Magical Quest 3 - Box Cover.jpg
// module id = 91
// module chunks = 0